import {
  CalculateUnitPricePayloadProps,
  QuotationProps,
  QuotationStatusEnum,
} from '@/types'

export const accordionsByStatusObject: Record<
  QuotationStatusEnum,
  Array<string>
> = {
  accepted: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  ready: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  active: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  cancelled: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  expired: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  created: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  pending: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  rejected: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
  pending_approval: ['general-information', 'order-data', 'catalog-products', 'logistic-data'],
}

export const getQuotationSuggestedUnitPricePayload = ({
  quotationValues,
}: {
  quotationValues: QuotationProps
}): CalculateUnitPricePayloadProps => {
  return {
    items: quotationValues?.products?.map((product) => ({
      cost: Number(product.cost) || 0,
      price: Number(product.price) || 0,
      quantity: Number(product.quantity) || 0,
      traderCommission: Number(product.traderCommission) || 0,
      cm3:
        Number(product?.catalogProduct?.category?.expectedCm3ProfitRate) || 0,
    })),
    customCost: Number(quotationValues.customsFreightCost || 0),
    firstMileCost: Number(quotationValues.firstMileFreightCost || 0),
    lastMileCost: Number(quotationValues.lastMileFreightCost || 0),
    discount: Number(quotationValues.discount || 0),
    includeIva: quotationValues?.includeIva || false,
    totalFreightPrice: Number(quotationValues?.totalFreightPrice || 0),
    deliveryOption: quotationValues?.deliveryOption || '',
    financingCost: quotationValues?.financingCost
      ? Number(quotationValues.financingCost || 0)
      : undefined,
  }
}

export const getQuotationWithOrdenedProducts = (
  quotation?: QuotationProps,
): QuotationProps | undefined => {
  if (!quotation) return

  const orderedItems = quotation?.products?.sort((a, b) => {
    return (
      new Date(a.createdAt || '').getTime() -
      new Date(b.createdAt || '').getTime()
    )
  })

  return {
    ...quotation,
    products: orderedItems,
  }
}
